export const base_path = process.env.REACT_APP_BASE_PATH || '';
export const img_path = process.env.REACT_APP_IMG_PATH || '';